"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
var action_1 = require("./action");
var langToIso4 = function (lang) {
    switch (lang) {
        case 'ar':
            return 'ar-EG';
        case 'en':
            return 'en-GB';
        default:
            return 'en-GB';
    }
};
var initialState = {
    language: { lang: '', langIso4: '', isRtl: false },
};
function languageReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case types_1.CHANGE_LANGUAGE: {
            if (state.language.lang === action.payload) {
                return state;
            }
            var isRtl = action_1.isRtlLanguage(action.payload);
            return __assign(__assign({}, state), { language: {
                    lang: action.payload,
                    langIso4: langToIso4(action.payload),
                    isRtl: isRtl,
                } });
        }
        default:
            return state;
    }
}
exports.languageReducer = languageReducer;
//# sourceMappingURL=reducer.js.map